import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query'

import { getLeadActivitiesApi } from 'services/lead'
import { leadActivityKey } from 'utils/constants/queryKey'
import { GetLeadActivitiesPayload } from 'services/types/lead'

export const PAGE_SIZE = 20
export const DEFAULT_RECORD_ID = 0

const useGetInfiniteListActivity = (getActivityParam: GetLeadActivitiesPayload, options?: { enabled?: boolean }) =>
  useInfiniteQuery(
    leadActivityKey.list(getActivityParam),
    ({ pageParam = DEFAULT_RECORD_ID }) =>
      getLeadActivitiesApi({
        ...getActivityParam,
        last_record_id: pageParam,
      }),
    {
      enabled: !!getActivityParam.lead_id && (options?.enabled ?? true),
    },
  )

const useInvalidateInfiniteList = () => {
  const queryClient = useQueryClient()

  return () => queryClient.invalidateQueries(leadActivityKey.lists())
}

export { useGetInfiniteListActivity, useInvalidateInfiniteList }
